/**
 * Polyfills for browser compatibility
 *
 * Must be imported FIRST in index.js before any other imports
 */

// Buffer polyfill for @ton/core
// @ton/core uses Node.js Buffer which isn't available in browsers
import { Buffer } from 'buffer';
window.Buffer = Buffer;

